<template>
  <TableBodyRow
    class="gw_table_body_row_hoverable gw_hvr hhandsrow"
    :class="{
      gw_table_body_row_active: handDetailItem.id === item.id,
    }"
    :thead="thead"
    @click="openHandDetail(), $emit('click')"
  >
    <TableBodyCell
      style="--max-width-td: 4rem; --min-width-td: 4rem; --padding-td: 0; justify-content: center"
      @click.stop
    >
      <div
        class="d-flex"
        style="gap: 0.5rem"
      >
        <Checkbox
          class="csst csst_nm flgmfslctr_title_controls_item"
          style="
            --icon-size: 1.25rem;
            --clr-disabled: var(--clr-grey-2);
            --clr-enabled: var(--clr-primary);
          "
          :value="isSelected"
          @click="$emit('toggle:selected')"
        >
          <template #content>
            <div
              class="csst_content text-nowrap clr-white"
              style="line-height: 1.2; left: calc(100% + 0.5rem)"
              v-html="$t('common.select')"
            />
          </template>
        </Checkbox>
        <Checkbox
          class="csst csst_nm flgmfslctr_title_controls_item"
          style="
            --icon-size: 1.25rem;
            --clr-disabled: var(--clr-grey-2);
            --clr-enabled: var(--clr-yellow);
          "
          :icons="['mdi-star-outline', 'mdi-star']"
          :value="item.marked"
          @click="$emit('toggle:marked')"
        >
          <template #content>
            <div
              class="csst_content text-nowrap clr-white"
              style="line-height: 1.2; left: calc(100% + 0.5rem)"
              v-html="$t(`common.${item.marked ? 'starred' : 'not_starred'}`)"
            />
          </template>
        </Checkbox>
      </div>
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.created_at"
      thKey="created_at"
    >
      {{ formatISODate(item.created_at) }}
    </TableBodyCell>

    <TableBodyCell
      v-show="thead.result"
      thKey="result"
    >
      <div
        v-if="item.correctness"
        class="mdi text-large csst csst_nm f-center h-100"
        :class="item.correctness.icon"
        :style="`color:var(${item.correctness.color})`"
      >
        <div
          class="csst_content line-height_1 clr-white"
          style="left: calc(100% + 0.5rem)"
        >
          {{ $t(`practice.${item.correctness.res_id}`) }}
        </div>
      </div>
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.format"
      thKey="format"
    >
      <CustomFormatOption
        v-if="item.custom_tree"
        :customTree="item.custom_tree"
        :keys="['players']"
      />
      <span
        v-else
        v-html="
          $t(`gametypes.groups.${item.game_mode.gametype.game_properties.format.toLowerCase()}`)
        "
      />
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.shortcut_type"
      thKey="shortcut_type"
    >
      <!-- fallback till BE show PREFLOP in spot type -->
      {{
        !item.spot_type && item.street === 'PREFLOP'
          ? $t(`shortcut.PREFLOP`)
          : item.spot_type
            ? $t(`shortcut.${item.spot_type.type}`)
            : ''
      }}
      <!-- {{ item.setup_shortcut ? $t(`shortcut.${item.setup_shortcut.label.type}`) : '' }} -->
    </TableBodyCell>

    <TableBodyCell
      v-show="thead.hero_position"
      thKey="hero_position"
    >
      {{ $t(`players.${item.hero_position}`) }}
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.hand"
      thKey="hand"
    >
      <div
        v-for="card in getCards(item.hand)"
        :key="card + 'streets'"
        style="--height: 1.75em; --value-size-increase: 0.9"
        :class="`poker-card poker-card_mini card_${card[1]}`"
      >
        <div class="card-value">
          {{ card[0] }}
        </div>
      </div>
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.board"
      thKey="board"
    >
      <div
        v-for="card in getCards(item.board)"
        :key="card + 'streets'"
        style="--height: 1.75em; --value-size-increase: 0.9"
        :class="`poker-card poker-card_mini card_${card[1]}`"
      >
        <div class="card-value">
          {{ card[0] }}
        </div>
      </div>
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.gto_score"
      thKey="gto_score"
    >
      <span
        v-if="!isNull(item.gto_score)"
        :style="`color:${getGtoScoreGroup(item.gto_score).clr}`"
      >
        {{ numFixed(item.gto_score * 100, 2) }}
      </span>
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.total_ev_loss"
      thKey="total_ev_loss"
    >
      <span
        v-if="!isNull(item.total_ev_loss)"
        :style="`color:${getEvLossGroup(item.total_ev_loss).clr}`"
      >
        {{ numFixed(item.total_ev_loss, 2) }}
      </span>
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.total_ev_loss_as_pot"
      thKey="total_ev_loss_as_pot"
    >
      <span
        v-if="!isNull(item.total_ev_loss_as_pot)"
        :style="`color:${getEvPotLossGroup(item.total_ev_loss_as_pot).clr}`"
      >
        {{ numFixed(item.total_ev_loss_as_pot * 100, 2) }}
      </span>
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.total_frequency_difference"
      thKey="total_frequency_difference"
    >
      <span v-if="!isNull(item.total_frequency_difference)">
        {{ numFixed(item.total_frequency_difference * 100, 2) }}
      </span>
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.actions"
      thKey="actions"
    >
      <StreetActionsCompactedV2
        v-if="item.actions_with_correctness"
        :streets="item.actions_with_correctness"
      />
    </TableBodyCell>
    <TableBodyCell
      class="gw_table_body_cell_sticky-noshadow"
      style="
        order: 99;
        --padding-td: 0;
        --z-index-td-sticky-left: unset;
        --z-index-td-sticky-right: 0;
      "
    >
      <div
        class="gw_btn text-medium weight_500 gw_hvr_content"
        style="position: absolute; right: 0.25rem"
      >
        <div class="mdi mdi-chevron-double-right mr-1"></div>
        {{ $t('btn.detail') }}
      </div>
    </TableBodyCell>
  </TableBodyRow>
</template>

<script>
import CustomFormatOption from '@/components/GameFormat/CustomFormatOption'
import StreetActionsCompactedV2 from '@/components/StreetActionsCompacted/StreetActionsCompactedV2'
import Checkbox from '@/components/Common/Checkbox/Checkbox'
import TableBodyRow from '@/components/DataTables/v2/TableBodyRow'
import TableBodyCell from '@/components/DataTables/v2/TableBodyCell'
import table_mix from '@/components/DataTables/table_mix'

export default {
  name: 'PracticeHandsTableV2Row',

  components: {
    TableBodyRow,
    TableBodyCell,
    CustomFormatOption,
    StreetActionsCompactedV2,
    Checkbox,
  },
  mixins: [table_mix],
  props: {
    item: Object,
    index: Number,
    thead: Object,
    isSelected: Boolean,
    handDetailItem: Object,
  },
  emits: ['click', 'toggle:selected', 'toggle:marked'],
  data() {
    return {}
  },
  methods: {
    openHandDetail() {
      this.$store.dispatch('api_call', {
        endpoint: `poker/practice/practice-hands/${this.item.id}/`,
        mutation: 'api_poker_practice_hand_detail',
        apiVersion: 'v1',
      })
      this.$store.dispatch('globals_drawer', {
        id: 'trainer_hand_history_item',
        open: true,
        item: this.item,
        maximized: this.$store.getters.globals_drawer.maximized,
      })
      this.$router
        .replace({
          query: {
            ...this.$route.query,
            hand_detail: this.item.id,
          },
        })
        .catch(() => {})
      // }
    },
    getGmfName(row) {
      // console.log(row. game_analysis.game_mode)
      // console.log(row)
      const gmf = this.$store.getters.gameformats.find(
        i => i.gametype === row.game_analysis?.game_mode?.gametype?.name,
      )
      const res = this.$t(`gametypes.groups.${(gmf?.group || '').toLowerCase()}`)
      return res
    },
    callhand() {
      // console.log(this.item)
      this.$store.dispatch('api_call', {
        apiVersion: 'v2',
        endpoint: `poker/hand-history/${this.item.id}`,
        hasCancel: false,
        // params,
      })
    },
    copyToClipboard(actionRange) {
      navigator.clipboard.writeText(JSON.stringify(this.item))
    },
  },
}
</script>
